import React, { useState } from 'react';
import axios from 'axios';
import { json, useLocation } from 'react-router-dom';
import { TextField, Button, Container, Typography, Grid2, Card } from '@mui/material';
import { useSnackbar } from './Utility/UserMessageContext';
import { resetPassword } from './API/LoginApi';
import { showSmallLoadingImage } from './Utility/Utility';

const ResetPassword = () => {
    const [waiting, setWaiting] = useState(false);
    const [password, setPassword] = useState('');
    const query = new URLSearchParams(useLocation().search);
    const token = query.get('token');
    const email = query.get('email');
    const { showSnackbar } = useSnackbar();

    const [confirmPassword, setConfirmPassword] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (password !== confirmPassword) {
            showSnackbar('Passwords do not match', 'error');
            return;
        }
        setWaiting(true);
        var result = await resetPassword(token, email, password);
        if(result.isSuccess){
            showSnackbar('Password has been reset successfully.', 'success');
            setWaiting(false);
            window.location.href = '/login';
        }
        else{
            showSnackbar(JSON.stringify(result?.data), 'error');
            console.log(JSON.stringify(result));
            setWaiting(false);
        }
    };

    return (
        <Grid2 container size={{ xs: 12, sm: 12, md: 6, lg: 4, xl: 3 }} spacing={2} sx={{ padding: 5 }}>
            <Card sx={{ padding: 3 }} variant='outlined'>
                <form onSubmit={handleSubmit}>
                    <Grid2>
                        <Typography variant="h6" gutterBottom></Typography>
                <Typography variant="h6" gutterBottom>
                    Reset password for {email}
                </Typography>
                </Grid2>
                <Grid2 size={12}>
                <TextField
                    label="New Password"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    fullWidth
                    margin="normal"
                    required
                    disabled={waiting}
                />
                </Grid2>
                <Grid2 size={12}>
                <TextField
                    label="Confirm Password"
                    type="password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    fullWidth
                    margin="normal"
                    required
                    disabled={waiting}
                />
                </Grid2>
                <Grid2 container size={12} sx={{justifyContent:"center", paddingTop:2}}>
                <Button type="submit" variant="contained" color="secondary" disabled={waiting}>
                    {waiting && showSmallLoadingImage()} Reset Password
                </Button>
                
                </Grid2>
                
                </form>
            {/* <Grid2 container size={12} sx={{overflow: 'hidden', paddingTop:2}} >
                    <Typography variant="body2" color="textSecondary">
                        Password Rule: It must be at least 12 characters long and contain at least one uppercase letter, one lowercase letter, one number, and one special character.
                    </Typography>
                </Grid2> */}
            </Card>
        </Grid2>

    );
};

export default ResetPassword;